module.exports = __webpack_public_path__ + "static/img/blue.c435b03a.png";